



        <div class="news-wrapper">
            <div class="news-banner"></div>
            <div class="title">News</div>
            <div class="description">Die neuesten Meldungen rund um Brother.</div>
            <div *ngFor="let newsletter of sortedData() | slice:0:4; let i=index">

                <a [href]="newsletter.htmlLink" target="_blank" class="one-new">
                    <div class="title-with-date">
                        <div class="font-bolder big">


                            {{ newsletter.subject }}</div>
                        <div class="small"> {{ newsletter.startDate | date:'dd MMM yyyy' }}</div>
                    </div>
                    <div bdFxFlex class="ml-auto my-auto news-link"> Mehr <bd-fa name="chevron-right"></bd-fa></div>
                </a>

            </div>
            <div class="news-btn">
                <a [routerLink]="['/news']" class="btn btn-primary small font-bold strict-sized-button mt-auto"
                (click)="onButtonClicked()">Alle News</a>
            </div>

        </div>



